import React, { useState, useEffect, useContext } from "react";
import GridComponent from "../components/grid/grid-comp";
import SearchComponent from "../components/search-comp";
import { useTranslation } from 'react-i18next';
import * as httpService from '../services/HTTPService';
import SpinLoader from "../components/spin-loader";
import { hideOverlay } from "../utils/utils";
import ScrollTopComp from "../components/scrollTop-comp";
import { ProductsContext } from "../context/productsContext";
import { PlaceholderHTML } from "../components/grid/grid-comp";
import {Grid} from 'react-virtualized';
import { useRef } from "react";
import { ViewportList } from "react-viewport-list";
import CreatePopup from "../components/create-moodboard/create";
import { useNavigate } from "react-router-dom";

const BrandPage = () => {
    const navigate = useNavigate();
    const ref = useRef(null);
    const { t, i18n } = useTranslation(); 
    const [data, setData] = useState([]);
    let [filteredData, setFilteredArray] = useState([]);
    let [isEmptyResult, setIsEmptyResult] = useState(false); 
    const [resultsLength, setResultsLength] = useState(0);
    const [isSearchPerformed, setIsSearchPerformed] = useState(false);
    let [context, setContext] = useContext(ProductsContext);
    let [products, setAllProducts] = useState(context);
    let [slicedProducts, setSlicedProducts] = useState([]);
    let [isSpinning, setIsSpinning] = useState(true);
    let [filterValue, setFilterValue] = useState('');
    const [moodboards, setMoodboards] = useState([]);
    const user = localStorage.getItem('auth-user');
    const authUser = JSON.parse(user);
    const email = authUser && authUser.email ? authUser.email : "";
    const [showCreate, setShowCreate] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const findABrandLbl  = i18n.exists("pages.findABrand") ? t('pages.findABrand') : "Намери brand";
    const findAMaterialLbl  = i18n.exists("pages.findAMaterial") ? t('pages.findAMaterial') : "Намери материал";
    const orderSampleLbl = i18n.exists("pages.orderSample") ? t('pages.orderSample') : "Поръчай мостра";
    const createLbl = i18n.exists("pages.create") ? t('pages.create') : "Направи";
    const moodboardLbl = i18n.exists("pages.moodboard") ? t('pages.moodboard') : "Moodboard";
    const makeAppointmentLbl =  i18n.exists("forms.makeAppointmentLbl") ? t('forms.makeAppointmentLbl') : "Запазете час за среща";
    const publicUrl = process.env.PUBLIC_URL;
    const defaultImg = publicUrl + "/img/no-photo.png";

// {imgUrl: "/img/partner-logos/alcantara.png", imgWidth: "155px"},
//         {imgUrl: "/img/partner-logos/studioart.png", imgWidth: "149px"},
//         {imgUrl: "/img/partner-logos/misia.png", imgWidth: "108px"},
//         {imgUrl: "/img/partner-logos/gandiablasco.png", imgWidth: "155px"},

    const brandsList = [
        { id: 1, brandName: "Studioart", imgUrl: "/img/partner-logos/studioart.png" },
        { id: 2, brandName: "Qurails", imgUrl: "/img/partner-logos/qurails.png" },
        { id: 3, brandName: "Sunbrella", imgUrl: "/img/partner-logos/Sunbrella.webp" },
        { id: 4, brandName: "Misia Paris", imgUrl: "/img/partner-logos/misia.png" },
        { id: 5, brandName: "NOBILIS", imgUrl: "/img/partner-logos/nobilis.png" },
        { id: 6, brandName: "Giardini", imgUrl: "/img/partner-logos/giardini.png" },
        { id: 7, brandName: "Fischbacher", imgUrl: "/img/partner-logos/fischbacher.png" },
        { id: 8, brandName: "Aldeco", imgUrl: "/img/partner-logos/aldeco.png" }
    ];

    const getDataSource = (data) => {
        setData(data);
    }

    const filterArray = (d) => {
        setIsSearchPerformed(true);
        setResultsLength(d.length);
        if(d && d.length > 0) {
            filteredData = d;
            setFilteredArray(d);
            setIsEmptyResult(false);
        }
        else {
            setIsEmptyResult(true);
        }
    }

    const getMoodboards = () => {
        if(email && email !== "") {
            httpService.getAllMoodboards(email).then((res) => {
                if(res) {
                    setMoodboards(res.data);
                }
            })
            .catch ((err) => console.log(err))
        }
    }

    const adjustSearchPerform = (isSearchPerf) => {
        setIsSearchPerformed(isSearchPerf);
    }

    const handleScroll = () => {
        // const element: any = window;
        let bottom =   Math.ceil(window.innerHeight + window.scrollY) > document.documentElement.scrollHeight - 300;
        //console.log(bottom);
        if(bottom && slicedProducts.length > 0) {
            const inputValue = document.querySelector('.search-control') ? document.querySelector('.search-control').value : "";
            // prevent loading more products when isSearchPerformed
            if(filteredData.length === 0 && filterValue === '' && inputValue === '') {
                fetchDataArray(slicedProducts.length, slicedProducts.length + 15);
                bottom = true;
                return bottom;
            }
        }
    }

    const fetchDataArray = (startIndex, count) => {
        const productsArray = [...products];
        if(startIndex > 0) {
            let slicedArr = [...slicedProducts];
            let newArray = slicedArr.concat(productsArray.slice(startIndex, count));
            slicedProducts = newArray;
            setSlicedProducts(newArray);
        }
        else {
            // initial slice
            slicedProducts = productsArray.slice(startIndex, count);
            setSlicedProducts(productsArray.slice(startIndex, count));
        }
    }

    const clearSearch = () => {
        setFilteredArray([]);
        setSlicedProducts(products.slice(0, 60));
    }

    const getSearchValue = (value) => {
        filterValue = value;
        setFilterValue(value);
        //console.log(filterValue)
    }

    const getProductsByBrand = () => {
        let productsArray = [...slicedProducts];
        if(slicedProducts.length === 0 && isSpinning === true) {
            const brandName = window.location.href.split('/').pop();
            httpService.getProductsByBrand(brandName).then((res) => {
                if(slicedProducts.length === 0 && isSpinning === true) {
                    console.log(res);
                    productsArray = res.data;
                    products = res.data;
                    setAllProducts(res.data);
                    context = res.data;
                    setContext(res.data);
                    isEmptyResult = false;
                    setIsEmptyResult(false);
                    slicedProducts = productsArray.slice(0, 60);
                    setSlicedProducts(productsArray.slice(0, 60))
                    //fetchDataArray(0, 60);
                    hideOverlay();
                    isSpinning = false;
                    setIsSpinning(false);
                    setTimeout(() => {
                        setShowMenu(true);
                    }, 50);
                }
            })
            .catch((err) => {
                console.log(err);
                hideOverlay();
                setIsSpinning(false);
            })
        }
    }

    const list = [
        ['Brian Vaughn', 'Software Engineer', 'San Jose', 'CA', 95125 /* ... */],
        // And so on...
      ];

    const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
        return (
            <div key={key} style={style}>
              {list[rowIndex][columnIndex]}
            </div>
          );
    }

    const leftMenuOnClick = (e) => {
        const id = e.target.id;
        if(id === "find-brand" || id === "find-mat") {
            const searchBar = document.querySelector('.search-control');
            if(searchBar) {
                searchBar.click();
                searchBar.focus();
            }
        }
        if(id === "create-board") {
            // open popup
            setShowCreate(!showCreate);
            //showOverlay();
        }
    }

    const hidePopup = (data) => {
        if(data) {
            setShowCreate(false);
        }
    }

    const LeftMenu = () => {
        return (
            <div className={showMenu ? "menu-fig left-menu" : "left-menu"}>
                <ul>
                    <li className="active-item" id="find-brand"><a href="/brands">{findABrandLbl}</a></li>
                    <li id="create-board" onClick={leftMenuOnClick}>{createLbl} {moodboardLbl}</li>
                    <li id="order"><a href="/cart">{orderSampleLbl}</a></li>
                    <li><a href="/appointment">{makeAppointmentLbl}</a></li>
                </ul>
                {showCreate ? (
                    <CreatePopup hide={hidePopup} />
                ) : null}
                <div className="menu-fig-line"></div>
            </div>
        )
    }

    const Brands = () => {

        const brandOnClick = (brandName) => {
            console.log(brandName);
           navigate(`/brands/${brandName}`);
           //history.push(`/brands/${brandName}`);
           
            // TODO: navigate to page with brand products
        }

        return (
            <ul className="brands-list">
                {brandsList.map((brand) => {
                    return (
                        <li key={brand.id} onClick={() => brandOnClick(brand.brandName)}>
                            <div className="brand-logo">
                                <img src={brand.imgUrl ? brand.imgUrl : defaultImg} alt ="brand-logo" />
                            </div>
                            <div>
                                <h3>{brand.brandName}</h3>
                            </div>
                        </li>
                    )
                })}
            </ul>
        )
    }


    useEffect(() => {
        if(slicedProducts.length === 0 && isSpinning === true) {
            getProductsByBrand();
        }
        else {
            // get the data from your context
            //fetchDataArray(0, 60);
            hideOverlay();
            setIsSpinning(false);
            setTimeout(() => {
                setShowMenu(true);
            }, 20);
        }

        getMoodboards();
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [])

    return (
        <div className="catalog-page">
            <h1 className="page-h1">{i18n.exists("pages.brands") ? t('pages.brands') : "brands"}</h1>
            <div className="content-wrapper">
                {/* <SearchComponent disabled={isSpinning} searchValue={getSearchValue} dataSource={products} isClear={clearSearch} filterArray={filterArray} isSearchPerf={adjustSearchPerform} /> */}
                <div className="catalog-page-inner">
                    {/* {isSearchPerformed ? (
                        <div className="results-label">
                            <span>{i18n.exists("pages.search") ? t('pages.search') : "Търсене"}</span>: 
                            <strong> {resultsLength} {i18n.exists("pages.productsCountLabel") ? t('pages.productsCountLabel') : "продукта"}</strong>
                        </div>
                    ) : null} */}
                    {slicedProducts.length > 0 ? (
                        <>
                            {products && products.length > 0 ? (
                                <LeftMenu />
                            ) : null}
                            
                            <GridComponent dataSource={getDataSource} products={slicedProducts} filteredData={filteredData} moodboards={moodboards} />
                        </>
                    ) : null}

                    {/* <Brands /> */}

                </div>
                {isSpinning ? (
                    <PlaceholderHTML />
                ) : null}
                <ScrollTopComp />
            </div>
        </div>
    )
}

export default BrandPage;